// extracted by mini-css-extract-plugin
export default {"container":"Admin_container__gXV82","singleUser":"Admin_singleUser__os+CX","card":"Admin_card__B7ywM","btn":"Admin_btn__JNlCO"};